// extracted by mini-css-extract-plugin
export default {"wrapper":"RoutesList_wrapper__PLLpc","header":"RoutesList_header__NcKd+","gameArt":"RoutesList_gameArt__xMIye"};